import * as React from 'react';

import { Box, ButtonProps } from '@mui/material';
import MuiBadge from '@mui/material/Badge';

import styled from '@emotion/styled';

import Button from '../../../components/Button/Button';
import SvgIcon from '../../../components/Icons';

type InviteSentButtonProps = {
  highlight?: boolean;
  /** Drop the label and keep just the icon — used when the toolbar is tight. */
  iconOnly?: boolean;
} & ButtonProps;

const COLOR = '#F4779F';

const Badge = styled(MuiBadge)({
  '.MuiBadge-dot': {
    backgroundColor: COLOR,
  },
});

const InviteSentButton: React.FC<InviteSentButtonProps> = ({
  highlight,
  iconOnly,
  sx,
  ...restProps
}) => {
  return (
    <Button
      id='btn-list-invite'
      aria-label='Collabs sent'
      startIcon={
        <Badge color='primary' variant='dot' invisible={!highlight}>
          <SvgIcon name='InviteSent' sx={{ fontSize: '20px' }} />
        </Badge>
      }
      sx={{
        ...sx,
        ...(iconOnly && {
          minWidth: 40,
          '& .MuiButton-startIcon': { mx: 0 },
        }),
      }}
      {...restProps}
    >
      {!iconOnly && (
        <Box component='span' sx={{ color: highlight ? COLOR : undefined }}>
          Collabs sent
        </Box>
      )}
    </Button>
  );
};

export default InviteSentButton;
